import { c as _c } from "react/compiler-runtime";
import Link from '@/components/elements/Link';
import Tooltip from '@/components/modules/Tooltip';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { BBookableReceptionTypeEnum } from '@/types/backend';
import { ReceptionTypeTag } from '@winelidays/wld-tsx-2/elements';
import { DoorIcon, InfoIcon } from '@winelidays/wld-tsx-2/images';
import { capitalize } from '@winelidays/wld-tsx-2/utils';
import PracticalLine from '../PracticalLine';
const ReceptionTypeContent = (t0) => {
    const $ = _c(7);
    const { informations } = t0;
    const translate = useTranslate();
    const isPrivate = "receptionType" in informations &&
        informations.receptionType === BBookableReceptionTypeEnum.Private;
    const infoClassName = `text-opacity-50 ${isPrivate ? "text-privilege" : "text-gray-400"}`;
    let t1;
    if ($[0] !== infoClassName || $[1] !== informations || $[2] !== translate) {
        t1 = "receptionType" in informations ? <>

      <Tooltip content={<>
          {capitalize(translate(`experience.reception.tooltip.${informations.receptionType}`))}</>} placement="top-end" className="font-semibold" appendTo="parent">

        <button className="inline-flex flex-row items-center">
          <ReceptionTypeTag receptionType={informations.receptionType} className="mr-2" translate={translate} linkComponent={Link}/>

          <span className={infoClassName}>
            <InfoIcon />
          </span>
        </button>
      </Tooltip></> : null;
        $[0] = infoClassName;
        $[1] = informations;
        $[2] = translate;
        $[3] = t1;
    }
    else {
        t1 = $[3];
    }
    const content = t1;
    let t2;
    if ($[4] !== content || $[5] !== translate) {
        t2 = content ?
            <PracticalLine icon={<DoorIcon />} label={capitalize(translate("experience.reception.label"))} content={content}/> : null;
        $[4] = content;
        $[5] = translate;
        $[6] = t2;
    }
    else {
        t2 = $[6];
    }
    return t2;
};
export default ReceptionTypeContent;
